<template>
	<div class="page">
		<div class="menu">
			<el-menu :default-active="menuIndex" @select="selectMenu">
				<el-menu-item :index="item.index" v-for="(item,index) in menuList" :key="index"
					:class="menuIndex == item.index ? 'menu_on' : ''">
					<span slot="title">{{ item.name }}</span>
				</el-menu-item>
			</el-menu>
		</div>
		<div class="info">
			<div class="form" v-if="menuIndex == '0'">
				<el-form label-width="100px" size="medium">
					<el-form-item label="是否包邮">
						<el-radio-group v-model="data.is_free">
						   <el-radio :label="1">开启</el-radio>
						   <el-radio :label="0">关闭</el-radio>
						 </el-radio-group>
					</el-form-item>
					<el-form-item label="首件数">
						<el-input-number v-model="data.first_unit" :min="0" controls-position="right"/> 
					</el-form-item>
					<el-form-item label="首件费用">
						<el-input-number v-model="data.first_price" :min="0" :precision="2" controls-position="right"/> 
					</el-form-item>
					<el-form-item label="续件数">
						<el-input-number v-model="data.continue_unit" :min="0" controls-position="right"/> 
					</el-form-item>
					<el-form-item label="续件价格">
						<el-input-number v-model="data.continue_price" :min="0" :precision="2" controls-position="right"/> 
					</el-form-item>
					<el-form-item label="满额包邮">
						<el-radio-group v-model="data.is_free_amount">
						   <el-radio :label="1">开启</el-radio>
						   <el-radio :label="0">关闭</el-radio>
						 </el-radio-group>
					</el-form-item>
					<el-form-item label="满额金额" v-if="data.is_free_amount == 1">
						<el-input-number v-model="data.free_amount" :min="0" :precision="2" controls-position="right"/> 
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary" @click="save(data)">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				menuIndex: '0',
				menuList: [{
						index: '0',
						name: '运费设置'
					},
				],
				data: {},
			};
		},
		mounted() {
			this.ActionDetail();
		},
		methods: {
			ActionDetail(){
				this.$get('sys-freight-template/1').then(res=>{
					this.data = res.data;
				}).catch(err=>{
					this.$warning(err);
				})
			},
			selectMenu(e) {
				this.menuIndex = e;
			},
			save(data){
				this.$load();
				this.$save('sys-freight-template', data).then(res=>{
					this.$load(false);
					this.$success('保存成功');
				}).catch(err=>{
					this.$load(false);
					this.$warning(err);
				})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.page {
		background-color: #fff;
		width: 100%;
		padding: 40px;
		display: flex;

		.menu {
			width: 10%;

			.menu_on {
				border-right: 2px solid #3E84E9;
			}
		}

		.info {
			margin-left: 40px;

			.form {
				margin-top: 30px;
				width: 600px;
			}
		}
	}
</style>